// import React from 'react'
// import styled from "styled-components";

// const Quality1 = () => {
//   return (
//     <>
//      <Quality>
//            <div className="quality-bg">
//            </div>
//         </Quality> 
//     </>
//   )
// }



//   const Quality = styled.section`
//   .quality-bg {
//     background-image: url(${process.env.PUBLIC_URL}/nature.png);
//     background-size: cover;
//     background-position: center; /* Center the image */
//     background-repeat: no-repeat; /* Prevent background from repeating */
//     display: flex;
//     width: 100%;
//     height: 100vh; /* Full viewport height */
//   }

//   @media (max-width: 768px) {
//     .quality-bg {
//       background-image: url(${process.env.PUBLIC_URL}/naturemobile.png);
//       background-size: contain;
//       background-position: top center;
//       width: 100%;
//       padding-top: 125%; /* Adjust this value based on the aspect ratio of the image */
//       height: 0; /* Set height to zero to make the height determined by padding */
//       display: flex;
//       align-items: flex-start; /* Align items to the top to avoid bottom whitespace */
//     }
//   }

//   @media (max-width: 480px) {
//     .quality-bg {
//       background-image: url(${process.env.PUBLIC_URL}/naturemobile.png);
//       background-size: contain;
//       background-position: top center;
//       width: 100%;
//       padding-top: 125%; /* Adjust this value based on the aspect ratio of the image */
//       height: 0; /* Set height to zero to make the height determined by padding */
//       display: flex;
//       align-items: flex-start; /* Align items to the top to avoid bottom whitespace */
//     }
//   }
// `;

// export default Quality1



import React from 'react';
import styled from "styled-components";

const Quality1 = () => {
  return (
    <>
     <Quality>
           <div className="quality-bg">
           </div>
        </Quality> 
    </>
  )
}

const Quality = styled.section`
  .quality-bg {
    background-image: url(${process.env.PUBLIC_URL}/nature.png);
    background-size: cover;
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Prevent background from repeating */
    width: 100%;
    height: 50vh; /* Half viewport height */
  }

  @media (max-width: 768px) {
    .quality-bg {
      background-image: url(${process.env.PUBLIC_URL}/naturemobile.png);
      background-size: cover;
      background-position: center;
      height: 50vh; /* Half viewport height */
    }
  }
`;

export default Quality1;
